import { render, staticRenderFns } from "./updateDeliveryPoints.vue?vue&type=template&id=24113f58&"
import script from "./updateDeliveryPoints.vue?vue&type=script&lang=js&"
export * from "./updateDeliveryPoints.vue?vue&type=script&lang=js&"
import style0 from "./updateDeliveryPoints.vue?vue&type=style&index=0&id=24113f58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports